// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.table-list {
  display: flex;
  width: 80rem;
  justify-content: center;
  margin-top: 30px;
}

th .order-4:before {
  margin-left: 3.5px;
  content: "\\2191";
  opacity: 0.4;
}

th .order-4:after {
  content: "\\2193";
  opacity: 0.4;
}

th .caret-4-asc:before {
  margin-left: 3.5px;
  content: "\\2191";
}

th .caret-4-asc:after {
  content: "\\2193";
  opacity: 0.4;
}

th .caret-4-desc:before {
  margin-left: 3.5px;
  content: "\\2191";
  opacity: 0.4;
}

th .caret-4-desc:after {
  content: "\\2193";
}

.wrapper {
  overflow: auto;
  align-items: center;
  justify-content: center;
  display: flex;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.dropdown-menu {
  right: 0 !important;
  left: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/App/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.table-list {\n  display: flex;\n  width: 80rem;\n  justify-content: center;\n  margin-top: 30px;\n}\n\nth .order-4:before {\n  margin-left: 3.5px;\n  content: \"\\2191\";\n  opacity: 0.4;\n}\n\nth .order-4:after {\n  content: \"\\2193\";\n  opacity: 0.4;\n}\n\nth .caret-4-asc:before {\n  margin-left: 3.5px;\n  content: \"\\2191\";\n}\n\nth .caret-4-asc:after {\n  content: \"\\2193\";\n  opacity: 0.4;\n}\n\nth .caret-4-desc:before {\n  margin-left: 3.5px;\n  content: \"\\2191\";\n  opacity: 0.4;\n}\n\nth .caret-4-desc:after {\n  content: \"\\2193\";\n}\n\n.wrapper {\n  overflow: auto;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.dropdown-menu {\n  right: 0 !important;\n  left: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
